import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 radial-gold" data-testid="admin-login-page">
      <form onSubmit={submit} className="glass rounded-2xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <div className="glass w-14 h-14 rounded-full flex items-center justify-center mx-auto text-gold mb-4"><Lock size={24} /></div>
          <h1 className="font-serif text-3xl">Administration</h1>
          <p className="text-sm text-muted-foreground mt-1">KMR Event — espace sécurisé</p>
        </div>
        <div className="space-y-4">
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-mail" required data-testid="admin-email"
            className="w-full bg-input/60 border border-white/10 rounded-xl px-4 py-3 focus:outline-none focus:border-gold/60 transition-colors" />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mot de passe" required data-testid="admin-password"
            className="w-full bg-input/60 border border-white/10 rounded-xl px-4 py-3 focus:outline-none focus:border-gold/60 transition-colors" />
          {error && <p className="text-destructive text-sm" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-btn"
            className="w-full inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 bg-gradient-to-r from-gold-light to-gold-dark text-background font-medium hover:brightness-110 transition-all">
            {loading ? <Loader2 size={18} className="animate-spin" /> : "Se connecter"}
          </button>
        </div>
      </form>
    </div>
  );
}
